import { formatPhone } from "@nmt/shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { errorMessage, post } from "../api";
import { Alert, Button, Dialog, Field } from "./ui";

/** Blocks a number in the CRM (and RingCentral, on production), asking why. */
export function BlockDialog({ number, name, onClose, onBlocked }: { number: string; name?: string | null; onClose: () => void; onBlocked?: () => void }) {
  const qc = useQueryClient();
  const [label, setLabel] = useState(name ?? "");
  const block = useMutation({
    mutationFn: () => post("/api/comms/blocked", { number, label: label.trim() }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["comm-threads"] });
      void qc.invalidateQueries({ queryKey: ["comms-blocked"] });
      onBlocked?.();
      onClose();
    },
  });
  const go = () => label.trim() && block.mutate();
  return (
    <Dialog
      title={`Block ${formatPhone(number)}?`}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="danger" busy={block.isPending} disabled={!label.trim()} onClick={go}>
            Block
          </Button>
        </>
      }
    >
      <form
        className="flex flex-col gap-3 text-sm"
        onSubmit={(e) => {
          e.preventDefault();
          go();
        }}
      >
        {block.error && <Alert>{errorMessage(block.error)}</Alert>}
        <Field label="Why (shown in the blocked list)" placeholder="Robocaller, solar sales…" value={label} maxLength={200} onChange={(e) => setLabel(e.target.value)} autoFocus />
        <p className="text-muted">Their calls stop popping up and automations never text them. In RingCentral they're blocked on each line the CRM watches. Unblock any time in Settings → Texts and calls.</p>
      </form>
    </Dialog>
  );
}
